import { render, staticRenderFns } from "./DefaultDesignationCreateEditModal.vue?vue&type=template&id=01666588"
import script from "./DefaultDesignationCreateEditModal.vue?vue&type=script&lang=js"
export * from "./DefaultDesignationCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports